import React from "react";
import SessionList from "./session-list";
import { VscChromeMinimize, VscCallIncoming } from "react-icons/vsc";
import { defaultChatBotSettings } from "../../consts/settings";
import { useQuery } from "../../helpers/hooks/common-hook";

export default function ChatHeader({ settingsState, chatBotSetting, toggleVoiceMode, onClose, sessionList }) {
  const query = useQuery();
  const title = chatBotSetting.title || defaultChatBotSettings.title;

  return (
    <header className="chat-header" style={{ backgroundColor: chatBotSetting.headerBackgroundColor, color: chatBotSetting.headerTextColor }}>
      <SessionList {...sessionList}>
      <span className="chat-header-identity">
        <span className={`chat-status-dot${settingsState.processing ? " is-loading" : ""}`} aria-hidden="true" />
        <span className="min-w-0">
          <span className="chat-header-title">{title}</span>
          <span className="chat-header-subtitle">
            {settingsState.processing ? "Getting ready…" : chatBotSetting.subTitle || "Ready to help"}
          </span>
        </span>
      </span>
      </SessionList>
      <div className="flex items-center gap-1 shrink-0">
        {query.get("test_voice_mode") && (
          <button type="button" onClick={toggleVoiceMode} className="chat-icon-button" aria-label="Start voice chat" title="Start voice chat">
            <VscCallIncoming size={19} />
          </button>
        )}
        {query.get("plugin") && (
          <button type="button" className="chat-icon-button" onClick={onClose} aria-label="Minimize chat" title="Minimize chat">
            <VscChromeMinimize size={20} />
          </button>
        )}
      </div>
    </header>
  );
}
